"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    PublicKey: '[u8; 20]',
    DestAddress: 'Vec<u8>'
  }
};
exports.default = _default;